import { ConnectProto } from "@racoon/api";

/**
 * Labels a picker offers: the active ones, plus `currentId` even if archived since, as it
 * stays assigned until another is picked. Ids arrive as strings at runtime
 * (connectBaseQuery normalizes bigints), so they are compared as strings.
 */
export const assignableLabels = (
  labels: ConnectProto.OrganizationLabel[] | undefined,
  currentId: string,
): ConnectProto.OrganizationLabel[] =>
  (labels ?? []).filter(
    (label) =>
      label.status === ConnectProto.LocationStatus.ACTIVE || label.id.toString() === currentId,
  );
